import { useEffect } from 'react';
import { useSidebarVisibilityStore } from '../store/sidebarVisibilityStore';

// Fetches sidebar visibility on mount and whenever the active site changes. The store dedupes
// concurrent calls and skips the request while cached data is fresh for the SAME site, so this is
// safe to call from layout-level components. Pass the active HaloPSA site id (from the app layer,
// which may read the auth store) so a site switch refetches the new site's visibility rather than
// serving the previous site's from cache. Omit it to keep plain TTL-only behaviour.
export const useSidebarVisibility = (siteId) => {
  const fetchVisibility = useSidebarVisibilityStore((s) => s.fetchVisibility);

  useEffect(() => {
    fetchVisibility({ siteId });
  }, [fetchVisibility, siteId]);
};
